module.exports = __webpack_public_path__ + "assets/9255c7250e164afcf1f931430c789f4b.png";